export function Select_simple({ 
    disabled = false, 
    value, // Se ha quitado el valor por defecto para manejar mejor el caso de uso
    options = [], 
    name, 
    onChange, 
    placeholder,
    multiple = false,
    size = 4,
    groups = null // Nueva prop para opciones agrupadas { groupLabel: [options] }
}) {
    const handleChange = (e) => {
        if (!onChange) return;
        
        if (multiple) {
            const selectedOptions = Array.from(e.target.selectedOptions).map(
                option => ({
                    id: option.value,
                    label: option.label
                })
            );
            onChange({
                target: {
                    name,
                    value: selectedOptions
                }
            });
        } else {
            onChange(e);
        }
    };

    const isMultiple = multiple;
    const selectValue = isMultiple
        ? (Array.isArray(value) ? value : [])
        : (value || ''); // Maneja el caso de valor nulo para selección simple

    // Función para renderizar opciones simples
    const renderOptions = (opts) => opts.map((option, index) => (
        <option value={option.value} key={`${option.value}-${index}`} disabled={option.disabled}>
            {option.label}
        </option>
    ));

    return (
        <select
            multiple={isMultiple}
            size={isMultiple ? size : undefined}
            disabled={disabled}
            value={selectValue}
            name={name}
            onChange={handleChange}
            className={`w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:border-blue-500 
                      dark:bg-gray-800 dark:text-white dark:border-gray-700 
                      ${isMultiple ? 'h-auto' : 'h-10'}`}
        >
            {placeholder && !isMultiple && <option value="">{placeholder}</option>}
            
            {groups ? (
                // Renderizar opciones agrupadas
                Object.entries(groups).map(([groupLabel, groupOptions]) => (
                    <optgroup label={groupLabel} key={groupLabel}>
                        {renderOptions(groupOptions)}
                    </optgroup>
                ))
            ) : (
                // Renderizar opciones planas
                renderOptions(options)
            )}
        </select>
    );
}

/*
{options.map((option, index) => {
                const formattedLabel = option.label
                    .toLowerCase()
                    .split(' ')
                    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                    .join(' ');
                
                return (
                    <option value={option.value} key={`${option.value}-${index}`}>
                        {formattedLabel}
                    </option>
                );
            })}
*/


//nuevo "mt-1 block w-full p-2 border border-gray-300 rounded-md"
//viejo "block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 px-3"